import * as moment from "moment";

export function timestamp(timestamp: number): string {
    return moment(new Date(timestamp)).tz("UTC").format("LLLL");
}

export function iso(timestamp: number): string {
    return moment(new Date(timestamp)).tz("UTC").format("YYYY-MM-DD HH:mm:ss");
}

export function tz(): string {
    return formatMinutes(moment().utcOffset());
}

function formatMinutes(minutes: number) {
    var sign = minutes > 0 ? "-" : "+";
    minutes = Math.abs(minutes);
    var hours = Math.floor(minutes / 60);
    var result = "";
    if (hours < 10) {
        result = "0" + hours + ":";
    } else {
        result = hours + ":";
    }
    var minutes = Math.floor(minutes - (hours * 60));
    if (minutes < 10) {
        result += "0" + minutes;
    } else {
        result += minutes;
    }
    return sign + result;

}



// WEBPACK FOOTER //
// ./src/app/utils/DateUtils.ts